<template>
	<page>
		<module title="策略信息">
			<c-form ref="form">
				<c-form-item type="input" label="策略名称" name="name" required></c-form-item>
				<c-form-item type="select" label="应用场景" name="apply_type" :options="applyType" required disabled></c-form-item>
				<c-form-item type="radio" label="展示方式" name="type" :options="displayType" required></c-form-item>
				<c-form-item type="datetime" label="生效时间" name="start_date" required></c-form-item>
				<c-form-item label="推荐商品" name="product_list" required>
					<draw-sort v-model="productList">
						<template v-slot="{list}">
							<div class="box">
								<div class="product-list flex-wrap flex-end-cross">
									<draw-item v-for="({item}, i) in list" :key="item.product_id" :index="i">
										<div class="product flex-center">
											<img :src="oss(item.product_img_url, 88, 88)">
											<a class="flex-center" @click="removeProduct(i)" @mousedown.stop><i class="tf tf-cross"></i></a>
										</div>
									</draw-item>
									
									<div class="product product-add flex-center" @click="$refs.productSelector.open()">
										<i class="tf tf-plus"></i>
									</div>
								</div>
							</div>
						</template>
					</draw-sort>
				</c-form-item>
				<c-form-item type="textarea" label="备注" name="remark"></c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="save()">保存</c-button>
			</template>
		</module>
		
		<product-selector ref="productSelector" multiple @resolve="addProduct"></product-selector>
	</page>
</template>

<script>
	import drawSort from '@/components/draw_sort/index.vue'
	import drawItem from '@/components/draw_sort/item.vue'
	import productSelector from '@/components/service/product_selector.vue'
	
	export default {
		name: 'recommended_edit',
		
		components: {
			drawSort, drawItem, productSelector
		},

		props: {
			id: String
		},

		data() {
			return {
				stateType:[{
					name:'启用',
					value:1
				}, {
					name:'禁用',
					value:2
				}],
				
				applyType:[
				    {name:'商品详情推荐',value:1},
				    {name:'购物车推荐',value:2},
				    {name:'支付成功页推荐',value:3},
            {name:'个人中心页推荐',value:4}
        ],
				displayType:[
				    {name:'随机展示',value:1},
            {name:'顺序展示',value:2}
        ],
				productList: []
			}
		},

		watch: {
			id() {
				this.getDetail();
			}
		},

		mounted() {
			if (this.id) {
				this.getDetail();
			}
		},

		methods: {
			getDetail() {
				this.request({
					url: '/recommended/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set(data);
						this.productList = data.recommended_product||[];
					}
				});
			},
			
			addProduct(data) {
          this.productList = this.productList.concat(data.filter(product => {
            return !this.productList.find(item => item.product_id == product.product_id);
          }));
			},
			
			removeProduct(index) {
				this.productList.splice(index, 1);
			},
			
			save() {
				this.$refs.form.submit({
					url: this.id ? '/recommended/edit' : '/recommended/add',
					rule: {
						name: '请填写策略名称',
						apply_type: '请选择应用场景',
						type: '请选择展示方式',
						start_date: '请选择生效时间',
						product_list: [{
							type: 'function',
							fun: () => {
								return this.productList.length > 0;
							},
							word: '请选择推荐商品'
						}]
					},
					dataFormatter: data => {
						data.id = this.id;
						data.product_ids = Array.from(this.productList, item => item.product_id);
						return data;
					},
					success: () => {
						this.$message({
							text: '操作成功'
						});
						this.$bus.$emit('recommendedList.update', {});
						this.redirectTo('/recommended_list');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.box {
		padding: 15px;
		background: #f9f8fb;
	}
	
	.product {
		position: relative;
		width: 90px;
		height: 90px;
		border: 1px solid #DDDDDD;
		margin-right: 15px;
		margin-top: 15px;
		background: #fff;
		box-sizing: border-box;
		
		video {
			width: 100%;
			height: 100%;
			background: #000;
		}
		
		a {
			position: absolute;
			right: 0;
			bottom: 0;
			width: 18px;
			height: 18px;
			font-size: 12px;
			color: #fff;
			background: #FF1010;
		}
		
		&-list {
			margin-top: -15px;
		}

		&-add {
			font-size: 20px;
			color: #ccc;
			cursor: pointer;
			transition: all .3s ease;
			
			&:hover {
				border-color: #bbb;
				color: #bbb;
			}
		}
	}
</style>